<!-- search bar -->
<div class="content-wrap">
    <div class="container">
        <form [formGroup]="userForm">
            <div class="breadcrumb">
                <a style="margin-right: 2px" href="">{{
                    'IRONSIDE.my-account.HOME' | translate
                }}</a>
                > {{ 'IRONSIDE.my-account.MY_ACCOUNT' | translate }}
            </div>
            <div
                class="title-catalogue d-flex justify-content-between align-items-center flex-wrap"
            >
                <h2>{{ 'IRONSIDE.my-account.MY_ACCOUNT' | translate }}</h2>
                <div class="btn-inner">
                    <!-- <button class="btn-common btn-modal me-3" (click)="visibleDeleteUser = true">
                        {{ isRequestedDeletion ? ('IRONSIDE.my-account.CANCEL_ACCOUNT_DELETION' | translate):('IRONSIDE.my-account.DELETE_ACCOUNT' | translate) }}
                    </button> -->

                    <p-dialog
                        [header]="
                            isRequestedDeletion
                                ? ('IRONSIDE.my-account.CANCEL_ACCOUNT_DELETION' | translate)
                                : ('IRONSIDE.my-account.DELETE_ACCOUNT' | translate)
                        "
                        [modal]="true"
                        [(visible)]="visibleDeleteUser"
                        [style]="{ width: '25rem' }"
                        [draggable]="false"
                    >
                        <form class="ironside" [formGroup]="deleteUserForm">
                            <p class="p-text-secondary block mb-2">
                                {{
                                    isRequestedDeletion
                                        ? ('IRONSIDE.my-account.CANCEL_DELETE_REQUIREMENTS'
                                          | translate)
                                        : ('IRONSIDE.my-account.DELETE_REQUIREMENTS' | translate)
                                }}
                            </p>
                            <div>
                                <p
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        align-items: flex-start;
                                        font-style: italic;
                                        font-size: 14px;
                                        color: #000;
                                    "
                                >
                                    <mat-icon style="font-size: 13px; height: 13px"
                                        >fiber_manual_record</mat-icon
                                    >
                                    {{
                                        'IRONSIDE.my-account.DESCRIPTION_PASSWORD_DELETE'
                                            | translate
                                    }}
                                </p>

                                <p
                                    *ngIf="!isRequestedDeletion"
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        align-items: flex-start;
                                        font-style: italic;
                                        font-size: 14px;
                                        color: #000;
                                    "
                                >
                                    <span>
                                        <mat-icon style="font-size: 13px; height: 13px"
                                            >fiber_manual_record
                                        </mat-icon>
                                    </span>
                                    {{ 'IRONSIDE.my-account.DESCRIPTION_REASON' | translate }}
                                </p>
                            </div>
                            <!-- PASSWORD -->
                            <div style="padding: 0 0 12px 0">
                                <mat-form-field
                                    style="width: 100%"
                                    appearance="outline"
                                    [ngClass]="{
                                        'mat-form-field-invalid':
                                            deleteUserForm.get('password')?.touched &&
                                            deleteUserForm.get('password')?.invalid,
                                        'mat-form-field-outline-thick':
                                            deleteUserForm.get('password')?.touched &&
                                            deleteUserForm.get('password')?.invalid
                                    }"
                                >
                                    <mat-label>{{
                                        'IRONSIDE.my-account.PASSWORD' | translate
                                    }}</mat-label>
                                    <input
                                        matInput
                                        type="password"
                                        [type]="hideOld ? 'password' : 'text'"
                                        name="password"
                                        [placeholder]="
                                            'IRONSIDE.my-account.ENTER_OLD_PASSWORD' | translate
                                        "
                                        formControlName="password"
                                        autocomplete="off"
                                    />

                                    <button
                                        mat-icon-button
                                        matSuffix
                                        (click)="hideOld = !hideOld"
                                        [attr.aria-label]="'Hide password'"
                                        [attr.aria-pressed]="hideOld"
                                        style="color: gray"
                                        type="button"
                                    >
                                        <mat-icon>{{
                                            hideOld ? 'visibility_off' : 'visibility'
                                        }}</mat-icon>
                                    </button>
                                </mat-form-field>
                                <div
                                    class="error-message"
                                    *ngIf="
                                        deleteUserForm.get('password')?.touched &&
                                        deleteUserForm.get('password')?.invalid
                                    "
                                >
                                    {{
                                        'IRONSIDE.my-account.required'
                                            | translate
                                                : {
                                                      field:
                                                          ('IRONSIDE.my-account.PASSWORD'
                                                          | translate)
                                                  }
                                    }}
                                </div>
                            </div>
                            <!-- DESCRIPTION -->
                            <div *ngIf="!isRequestedDeletion" style="padding: 0 0 12px 0">
                                <mat-form-field
                                    style="width: 100%"
                                    [style.fontSize]="12"
                                    [ngClass]="{
                                        'mat-form-field-invalid':
                                            deleteUserForm.get('reason')?.touched &&
                                            deleteUserForm.get('reason')?.invalid,
                                        'mat-form-field-outline-thick':
                                            deleteUserForm.get('reason')?.touched &&
                                            deleteUserForm.get('reason')?.invalid
                                    }"
                                >
                                    <mat-label style="font-size: 12px">{{
                                        'IRONSIDE.my-account.REASON' | translate
                                    }}</mat-label>
                                    <textarea
                                        matInput
                                        style="font-size: 12px"
                                        cdkTextareaAutosize
                                        cdkAutosizeMinRows="2"
                                        cdkAutosizeMaxRows="5"
                                        formControlName="reason"
                                        [placeholder]="
                                            'IRONSIDE.my-account.ENTER_REASON' | translate
                                        "
                                    ></textarea>
                                </mat-form-field>
                                <div
                                    class="error-message"
                                    *ngIf="
                                        deleteUserForm.get('reason')?.touched &&
                                        deleteUserForm.get('reason')?.invalid
                                    "
                                >
                                    {{
                                        'IRONSIDE.my-account.required'
                                            | translate
                                                : {
                                                      field:
                                                          ('IRONSIDE.my-account.REASON' | translate)
                                                  }
                                    }}
                                </div>
                            </div>
                            <div class="flex justify-content-end gap-2">
                                <button
                                    [disabled]="loading"
                                    class="btn-common btn-modal me-3"
                                    (click)="onCloseChangePasswordForm()"
                                >
                                    {{ 'IRONSIDE.no' | translate }}
                                </button>
                                <button
                                    [ngStyle]="{
                                        'background-color': deleteUserForm.invalid
                                            ? '#0000006e'
                                            : '#000',
                                        border: deleteUserForm.invalid
                                            ? '1px solid #0000006e'
                                            : '1px solid #000'
                                    }"
                                    [disabled]="deleteUserForm.invalid || loading"
                                    class="btn-common btn-modal me-3"
                                    (click)="onDeleteUser()"
                                >
                                    {{
                                        isRequestedDeletion
                                            ? ('IRONSIDE.my-account.CANCEL_DELETE' | translate)
                                            : ('IRONSIDE.my-account.DELETE' | translate)
                                    }}
                                </button>
                            </div>
                        </form>

                        <ng-container *ngIf="loading">
                            <div class="secsion-loading">
                                <mat-spinner [diameter]="50"></mat-spinner>
                            </div>
                        </ng-container>
                    </p-dialog>

                    <button
                        class="btn-common btn-modal me-3"
                        (click)="visibleChangePassword = true"
                    >
                        {{ 'IRONSIDE.my-account.CHANGE_PASSWORD' | translate }}
                    </button>
                    <p-dialog
                        [header]="'IRONSIDE.my-account.CHANGE_PASSWORD' | translate"
                        [modal]="true"
                        [(visible)]="visibleChangePassword"
                        [style]="{ width: '25rem' }"
                        [draggable]="false"
                    >
                        <form class="ironside" [formGroup]="passwordChangeForm">
                            <p class="p-text-secondary block mb-2">
                                {{ 'IRONSIDE.my-account.PASSWORD_REQUIREMENTS' | translate }}
                            </p>
                            <div>
                                <p
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        align-items: flex-start;
                                        font-style: italic;
                                        font-size: 14px;
                                        color: #000;
                                    "
                                >
                                    <span
                                        [ngSwitch]="
                                            lengthNewPassword === 0
                                                ? 'default'
                                                : validateNewPassword.includes('minLength')
                                                ? 'valid'
                                                : 'invalid'
                                        "
                                    >
                                        <mat-icon
                                            style="font-size: 13px; height: 13px; color: green"
                                            *ngSwitchCase="'valid'"
                                            >check_circle</mat-icon
                                        >
                                        <mat-icon
                                            style="font-size: 13px; height: 13px; color: red"
                                            *ngSwitchCase="'invalid'"
                                            >report</mat-icon
                                        >
                                        <mat-icon
                                            style="font-size: 13px; height: 13px"
                                            *ngSwitchDefault
                                            >fiber_manual_record</mat-icon
                                        >
                                    </span>
                                    {{ 'IRONSIDE.my-account.MINIMUM_LENGTH' | translate }}
                                </p>
                                <p
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        align-items: flex-start;
                                        font-style: italic;
                                        font-size: 14px;
                                        color: #000;
                                    "
                                >
                                    <span
                                        [ngSwitch]="
                                            lengthNewPassword === 0
                                                ? 'default'
                                                : validateNewPassword.includes('digit')
                                                ? 'valid'
                                                : 'invalid'
                                        "
                                    >
                                        <mat-icon
                                            *ngSwitchCase="'valid'"
                                            style="font-size: 13px; height: 13px; color: green"
                                        >
                                            check_circle
                                        </mat-icon>

                                        <mat-icon
                                            *ngSwitchCase="'invalid'"
                                            style="font-size: 13px; height: 13px; color: red"
                                        >
                                            report
                                        </mat-icon>

                                        <mat-icon
                                            *ngSwitchDefault
                                            style="font-size: 13px; height: 13px"
                                        >
                                            fiber_manual_record
                                        </mat-icon>
                                    </span>
                                    {{ 'IRONSIDE.my-account.CONTAINS_DIGIT' | translate }}
                                </p>
                                <p
                                    style="
                                        display: flex;
                                        flex-direction: row;
                                        align-items: flex-start;
                                        font-style: italic;
                                        font-size: 14px;
                                        color: #000;
                                    "
                                >
                                    <span
                                        [ngSwitch]="
                                            lengthNewPassword === 0
                                                ? 'default'
                                                : validateNewPassword.includes('specialChar')
                                                ? 'valid'
                                                : 'invalid'
                                        "
                                    >
                                        <mat-icon
                                            style="font-size: 13px; height: 13px; color: green"
                                            *ngSwitchCase="'valid'"
                                            >check_circle</mat-icon
                                        >
                                        <mat-icon
                                            style="font-size: 13px; height: 13px; color: red"
                                            *ngSwitchCase="'invalid'"
                                            >report</mat-icon
                                        >
                                        <mat-icon
                                            style="font-size: 13px; height: 13px"
                                            *ngSwitchDefault
                                            >fiber_manual_record</mat-icon
                                        > </span
                                    >{{ 'IRONSIDE.my-account.CONTAINS_SPECIAL_CHAR' | translate }}
                                </p>
                            </div>

                            <div class="password-form">
                                <div style="padding: 0 0 12px 0">
                                    <mat-form-field
                                        style="width: 100%"
                                        appearance="outline"
                                        [ngClass]="{
                                            'mat-form-field-invalid':
                                                passwordChangeForm.get('oldPassword')?.touched &&
                                                passwordChangeForm.get('oldPassword')?.invalid,
                                            'mat-form-field-outline-thick':
                                                passwordChangeForm.get('oldPassword')?.touched &&
                                                passwordChangeForm.get('oldPassword')?.invalid
                                        }"
                                    >
                                        <mat-label>{{
                                            'IRONSIDE.my-account.OLD_PASSWORD' | translate
                                        }}</mat-label>
                                        <input
                                            matInput
                                            type="password"
                                            [type]="hideOld ? 'password' : 'text'"
                                            name="oldPassword"
                                            [placeholder]="
                                                'IRONSIDE.my-account.ENTER_OLD_PASSWORD' | translate
                                            "
                                            formControlName="oldPassword"
                                            autocomplete="off"
                                        />

                                        <button
                                            mat-icon-button
                                            matSuffix
                                            (click)="hideOld = !hideOld"
                                            [attr.aria-label]="'Hide password'"
                                            [attr.aria-pressed]="hideOld"
                                            style="color: gray"
                                            type="button"
                                        >
                                            <mat-icon>{{
                                                hideOld ? 'visibility_off' : 'visibility'
                                            }}</mat-icon>
                                        </button>
                                    </mat-form-field>
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            passwordChangeForm.get('oldPassword')?.touched &&
                                            passwordChangeForm.get('oldPassword')?.invalid
                                        "
                                    >
                                        {{
                                            'IRONSIDE.my-account.required'
                                                | translate
                                                    : {
                                                          field:
                                                              ('IRONSIDE.my-account.OLD_PASSWORD'
                                                              | translate)
                                                      }
                                        }}
                                    </div>
                                </div>
                                <div style="padding: 0 0 12px 0">
                                    <mat-form-field
                                        style="width: 100%"
                                        appearance="outline"
                                        [ngClass]="{
                                            'mat-form-field-invalid':
                                                passwordChangeForm.get('newPassword')?.touched &&
                                                passwordChangeForm.get('newPassword')?.invalid,
                                            'mat-form-field-outline-thick':
                                                passwordChangeForm.get('newPassword')?.touched &&
                                                passwordChangeForm.get('newPassword')?.invalid
                                        }"
                                    >
                                        <mat-label>{{
                                            'IRONSIDE.my-account.NEW_PASSWORD' | translate
                                        }}</mat-label>
                                        <input
                                            matInput
                                            type="password"
                                            [type]="hideNew ? 'password' : 'text'"
                                            name="newPassword"
                                            [placeholder]="
                                                'IRONSIDE.my-account.ENTER_NEW_PASSWORD' | translate
                                            "
                                            formControlName="newPassword"
                                            autocomplete="off"
                                        />

                                        <button
                                            mat-icon-button
                                            matSuffix
                                            (click)="hideNew = !hideNew"
                                            [attr.aria-label]="'Hide password'"
                                            [attr.aria-pressed]="hideNew"
                                            style="color: gray"
                                            type="button"
                                        >
                                            <mat-icon>{{
                                                hideNew ? 'visibility_off' : 'visibility'
                                            }}</mat-icon>
                                        </button>
                                    </mat-form-field>
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            passwordChangeForm.get('newPassword')?.touched &&
                                            passwordChangeForm.get('newPassword')?.invalid
                                        "
                                    >
                                        {{
                                            'IRONSIDE.my-account.required'
                                                | translate
                                                    : {
                                                          field:
                                                              ('IRONSIDE.my-account.NEW_PASSWORD'
                                                              | translate)
                                                      }
                                        }}
                                    </div>
                                </div>

                                <div style="padding: 0 0 12px 0">
                                    <mat-form-field
                                        style="width: 100%"
                                        appearance="outline"
                                        [ngClass]="{
                                            'mat-form-field-invalid':
                                                (passwordChangeForm.get('confirmedNewPassword')
                                                    ?.touched &&
                                                    passwordChangeForm.get('confirmedNewPassword')
                                                        ?.invalid) ||
                                                (passwordChangeForm.get('confirmedNewPassword')
                                                    ?.touched &&
                                                    passwordChangeForm.hasError(
                                                        'passwordMismatch'
                                                    )),
                                            'mat-form-field-outline-thick':
                                                (passwordChangeForm.get('confirmedNewPassword')
                                                    ?.touched &&
                                                    passwordChangeForm.get('confirmedNewPassword')
                                                        ?.invalid) ||
                                                (passwordChangeForm.get('confirmedNewPassword')
                                                    ?.touched &&
                                                    passwordChangeForm.hasError('passwordMismatch'))
                                        }"
                                    >
                                        <mat-label>{{
                                            'IRONSIDE.my-account.CONFIRM_PASSWORD' | translate
                                        }}</mat-label>
                                        <input
                                            matInput
                                            type="password"
                                            [type]="hideConfirm ? 'password' : 'text'"
                                            name="confirmedNewPassword"
                                            [placeholder]="
                                                'IRONSIDE.my-account.ENTER_CONFIRM_PASSWORD'
                                                    | translate
                                            "
                                            formControlName="confirmedNewPassword"
                                            autocomplete="off"
                                        />
                                        <button
                                            mat-icon-button
                                            matSuffix
                                            (click)="hideConfirm = !hideConfirm"
                                            [attr.aria-label]="'Hide password'"
                                            [attr.aria-pressed]="hideConfirm"
                                            style="color: gray"
                                            type="button"
                                        >
                                            <mat-icon>{{
                                                hideConfirm ? 'visibility_off' : 'visibility'
                                            }}</mat-icon>
                                        </button>
                                    </mat-form-field>
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            passwordChangeForm.get('confirmedNewPassword')
                                                ?.touched &&
                                            passwordChangeForm.get('confirmedNewPassword')?.invalid
                                        "
                                    >
                                        {{
                                            'IRONSIDE.my-account.required'
                                                | translate
                                                    : {
                                                          field:
                                                              ('IRONSIDE.my-account.ENTER_CONFIRM_PASSWORD'
                                                              | translate)
                                                      }
                                        }}
                                    </div>
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            passwordChangeForm.get('confirmedNewPassword')
                                                ?.touched &&
                                            passwordChangeForm.hasError('passwordMismatch')
                                        "
                                    >
                                        {{
                                            'IRONSIDE.my-account.AUTH_PASSWORDS_DO_NOT_MATCH'
                                                | translate
                                        }}
                                    </div>
                                </div>
                                <div class="flex justify-content-end gap-2">
                                    <button
                                        [disabled]="loading"
                                        class="btn-common btn-modal me-3"
                                        (click)="onCloseChangePasswordForm()"
                                    >
                                        {{ 'IRONSIDE.no' | translate }}
                                    </button>
                                    <button
                                        [ngStyle]="{
                                            'background-color':
                                                passwordChangeForm.invalid ||
                                                validateNewPassword.length < 3
                                                    ? '#0000006e'
                                                    : '#000',
                                            border:
                                                passwordChangeForm.invalid ||
                                                validateNewPassword.length < 3
                                                    ? '1px solid #0000006e'
                                                    : '1px solid #0000006e'
                                        }"
                                        [disabled]="
                                            passwordChangeForm.invalid ||
                                            validateNewPassword.length < 3 ||
                                            loading
                                        "
                                        class="btn-common btn-modal me-3"
                                        (click)="onChangeSubmitPassword()"
                                    >
                                        {{ 'IRONSIDE.my-account.CHANGE' | translate }}
                                    </button>
                                </div>
                            </div>
                        </form>
                        <ng-container *ngIf="loading">
                            <div class="secsion-loading">
                                <mat-spinner [diameter]="50"></mat-spinner>
                            </div>
                        </ng-container>
                    </p-dialog>
                    <button
                        [disabled]="userForm.invalid"
                        class="btn-common btn-modal"
                        (click)="save()"
                    >
                        {{ 'IRONSIDE.my-account.SAVE' | translate }}
                    </button>
                </div>
            </div>
            <div class="informations-partenaires d-flex flex-wrap">
                <div class="col-md-3 informations-title mb-2">
                    {{ 'IRONSIDE.my-account.PERSONAL_INFORMATION' | translate }}
                </div>
                <div class="col-md-9 informations-content">
                    <h3>{{ 'IRONSIDE.my-account.PERSONAL_INFORMATION' | translate }}</h3>
                    <div class="informations-form">
                        <div class="row">
                            <div class="item-input">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">{{
                                        'IRONSIDE.my-account.LAST_NAME' | translate
                                    }}</label>
                                    <input
                                        [ngStyle]="{
                                            border:
                                                userForm.get('nom')?.touched &&
                                                userForm.get('nom')?.invalid
                                                    ? '1px solid #C82121'
                                                    : ''
                                        }"
                                        type="text"
                                        placeholder="{{
                                            'IRONSIDE.my-account.LAST_NAME' | translate
                                        }}"
                                        formControlName="nom"
                                    />
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            userForm.get('nom')?.touched &&
                                            userForm.get('nom')?.invalid
                                        "
                                    >
                                        {{
                                            'IRONSIDE.my-account.required'
                                                | translate
                                                    : {
                                                          field:
                                                              ('IRONSIDE.my-account.LAST_NAME'
                                                              | translate)
                                                      }
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="item-input">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">{{
                                        'IRONSIDE.my-account.FIRST_NAME' | translate
                                    }}</label>
                                    <input
                                        [ngStyle]="{
                                            border:
                                                userForm.get('prenom')?.touched &&
                                                userForm.get('prenom')?.invalid
                                                    ? '1px solid #C82121'
                                                    : ''
                                        }"
                                        type="text"
                                        placeholder="{{
                                            'IRONSIDE.my-account.FIRST_NAME' | translate
                                        }}"
                                        formControlName="prenom"
                                    />
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            userForm.get('prenom')?.touched &&
                                            userForm.get('prenom')?.invalid
                                        "
                                    >
                                        {{
                                            'IRONSIDE.my-account.required'
                                                | translate
                                                    : {
                                                          field:
                                                              ('IRONSIDE.my-account.FIRST_NAME'
                                                              | translate)
                                                      }
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div class="item-input">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">{{
                                        'IRONSIDE.my-account.FUNCTION' | translate
                                    }}</label>
                                    <input
                                        [ngStyle]="{
                                            border:
                                                userForm.get('function')?.touched &&
                                                userForm.get('function')?.invalid
                                                    ? '1px solid #C82121'
                                                    : ''
                                        }"
                                        type="text"
                                        placeholder="{{
                                            'IRONSIDE.my-account.FUNCTION' | translate
                                        }}"
                                        formControlName="function"
                                    />
                                </div>
                            </div>

                            <div class="item-input">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">{{
                                        'IRONSIDE.my-account.EMAIL_ADDRESS' | translate
                                    }}</label>
                                    <input
                                        [ngStyle]="{
                                            border:
                                                userForm.get('email')?.touched &&
                                                userForm.get('email')?.invalid
                                                    ? '1px solid #C82121'
                                                    : ''
                                        }"
                                        type="text"
                                        placeholder="{{
                                            'IRONSIDE.my-account.EMAIL_ADDRESS' | translate
                                        }}"
                                        formControlName="email"
                                    />
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            userForm.get('email')?.touched &&
                                            userForm.get('email')?.invalid
                                        "
                                    >
                                        {{
                                            'IRONSIDE.my-account.required'
                                                | translate
                                                    : {
                                                          field:
                                                              ('IRONSIDE.my-account.EMAIL_ADDRESS'
                                                              | translate)
                                                      }
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="item-input">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">{{
                                        'IRONSIDE.my-account.PHONE' | translate
                                    }}</label>
                                    <input
                                        [ngStyle]="{
                                            border:
                                                userForm.get('tel')?.touched &&
                                                userForm.get('tel')?.invalid
                                                    ? '1px solid #C82121'
                                                    : ''
                                        }"
                                        type="text"
                                        placeholder="{{ 'IRONSIDE.my-account.PHONE' | translate }}"
                                        formControlName="tel"
                                    />
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            userForm.get('tel')?.touched &&
                                            userForm.get('tel')?.invalid
                                        "
                                    >
                                        {{
                                            'IRONSIDE.my-account.required'
                                                | translate
                                                    : {
                                                          field:
                                                              ('IRONSIDE.my-account.PHONE'
                                                              | translate)
                                                      }
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="item-input">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">{{
                                        'IRONSIDE.my-account.MOBILE' | translate
                                    }}</label>
                                    <input
                                        [ngStyle]="{
                                            border:
                                                userForm.get('mobile')?.touched &&
                                                userForm.get('mobile')?.invalid
                                                    ? '1px solid #C82121'
                                                    : ''
                                        }"
                                        type="text"
                                        placeholder="{{ 'IRONSIDE.my-account.MOBILE' | translate }}"
                                        formControlName="mobile"
                                    />
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            userForm.get('mobile')?.touched &&
                                            userForm.get('mobile')?.invalid
                                        "
                                    >
                                        {{
                                            'IRONSIDE.my-account.required'
                                                | translate
                                                    : {
                                                          field:
                                                              ('IRONSIDE.my-account.MOBILE'
                                                              | translate)
                                                      }
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div class="item-input">
                                <div class="wrap-input">
                                    <label class="mb-0" for="">{{
                                        'IRONSIDE.my-account.CIVILITY' | translate
                                    }}</label>
                                    <div class="col-xl-2 col-lg-2 col-md-2" style="width: 100%">
                                        <div class="wrap-select">
                                            <label for="">{{
                                                'IRONSIDE.my-account.CIVILITY' | translate
                                            }}</label>
                                            <p-dropdown
                                                [ngStyle]="{
                                                    border:
                                                        userForm.get('civility')?.touched &&
                                                        userForm.get('civility')?.invalid
                                                            ? '1px solid #C82121'
                                                            : ''
                                                }"
                                                [options]="civilitiesDataOption"
                                                class="w-12"
                                                optionValue="parameterId"
                                                [placeholder]="
                                                    'IRONSIDE.choose-a-category' | translate
                                                "
                                                formControlName="civility"
                                            >
                                                <ng-template let-civility pTemplate="item">
                                                    <div class="flex align-items-center gap-2">
                                                        <div class="truncate">
                                                            {{
                                                                civility.labels
                                                                    | translateDynamicLanguage
                                                            }}
                                                        </div>
                                                    </div>
                                                </ng-template>

                                                <ng-template let-civility pTemplate="selectedItem">
                                                    <div class="flex align-items-center gap-2">
                                                        <div
                                                            class="truncate"
                                                            style="
                                                                font-size: 14px;
                                                                color: #000000c9;
                                                            "
                                                        >
                                                            {{
                                                                civility.labels
                                                                    | translateDynamicLanguage
                                                            }}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                            <div
                                                class="error-message"
                                                *ngIf="
                                                    userForm.get('civility')?.touched &&
                                                    userForm.get('civility')?.invalid
                                                "
                                            >
                                                {{
                                                    'IRONSIDE.my-account.required'
                                                        | translate
                                                            : {
                                                                  field:
                                                                      ('IRONSIDE.my-account.CIVILITY'
                                                                      | translate)
                                                              }
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="unsubscribe mb-8">
                <a style="cursor: pointer" (click)="visibleDeleteUser = true">{{
                    isRequestedDeletion
                        ? ('IRONSIDE.my-account.CANCEL_UNSUBSCRIBE' | translate)
                        : ('IRONSIDE.my-account.UNSUBSCRIBE' | translate)
                }}</a>
            </div>
        </form>
    </div>
</div>
<p-toast></p-toast>
